<script>
  export let idInterno;

  import QuestionTitle from "../components/QuestionTitle.svelte";
  import Question from "../components/Question.svelte";

  import { post } from "../js/api";
  import { UEX } from "../js/domains";
  import { sanitizeString } from "../js/sanitizeString";

  import { onMount } from "svelte";

  import { navigate } from "svelte-routing";

  let surveyId = -1;

  let profesor = "";
  let asignatura = "";
  let cuestionario = [];
  let cuestionario1 = [];
  let cuestionario2 = [];
  let cuestionario3 = [];
  let cuestionario4 = [];
  let cuestionario5 = [];
  let cuestionario6 = [];
  let tipoEvaluacion = "teoria";

  let respuestas = [];
  let respuestasError = [];

  let comentariosProfesor = "";

  let closeCode = "";

  let academicYear = "";

  let loaded = false;

  onMount(() => {
    getEvaluacion();
    calculateYearPeriod();
  });

  let calculateYearPeriod = () => {
    const today = moment();
    const month = today.format("MM");
    const year = parseInt(today.format("YYYY"));
    academicYear =
      month === "09" || month === "10" || month === "11" || month === "12"
        ? year + "-" + (year + 1)
        : year - 1 + "-" + year;
  };

  let getEvaluacion = async () => {
    const response = await post("RecibirEvaluacion", {
      idInterno,
    });

    if (response.length === 0) {
      navigate(UEX, { replace: true });
      return;
    }

    surveyId = response.id;
    profesor = response.profesor;
    asignatura = response.asignatura;
    cuestionario = response.preguntas;
    tipoEvaluacion = response.tipoEvaluacion;

    if (tipoEvaluacion === "teoria") {
      cuestionario1 = cuestionario.filter((item, index) => {
        return index >= 0 && index <= 1;
      });
      cuestionario2 = cuestionario.filter((item, index) => {
        return index >= 2 && index <= 8;
      });
      cuestionario3 = cuestionario.filter((item, index) => {
        return index >= 9 && index <= 12;
      });
    } else {
      cuestionario1 = cuestionario.filter((item, index) => {
        return index >= 0 && index <= 5;
      });
      cuestionario2 = cuestionario.filter((item, index) => {
        return index >= 6 && index <= 8;
      });
      cuestionario3 = cuestionario.filter((item, index) => {
        return index >= 9 && index <= 11;
      });
      cuestionario4 = cuestionario.filter((item, index) => {
        return index >= 12 && index <= 14;
      });
      cuestionario5 = cuestionario.filter((item, index) => {
        return index >= 15 && index <= 15;
      });
      cuestionario6 = cuestionario.filter((item, index) => {
        return index >= 16 && index <= 18;
      });
    }

    respuestas = cuestionario.map(() => {
      return "";
    });
    respuestasError = cuestionario.map(() => {
      return false;
    });

    loaded = true;
  };

  let clickAnswer = (questionIndex, answer) => {
    //console.log(questionIndex, answer);
    respuestas[questionIndex] = answer;
    //console.log(respuestas);
  };

  let checkCloseCode = () => {
    closeCode = closeCode.toUpperCase();
  };

  let sendCuestionario = async () => {
    closeCode = closeCode.trim();

    respuestasError = respuestas.map((r) => {
      return r === "";
    });

    const errorPos = respuestasError.findIndex((item) => {
      return item === true;
    });
    if (errorPos >= 0) {
      document.getElementById("q" + (errorPos + 1)).scrollIntoView();

      return;
    }

    loaded = false;

    let response = null;

    if (tipoEvaluacion === "teoria") {
      response = await post("EnviarEvaluacion", {
        idEvaluacion: surveyId,
        respuesta1: respuestas[0],
        respuesta2: respuestas[1],
        respuesta3: respuestas[2],
        respuesta4: respuestas[3],
        respuesta5: respuestas[4],
        respuesta6: respuestas[5],
        respuesta7: respuestas[6],
        respuesta8: respuestas[7],
        respuesta9: respuestas[8],
        respuesta10: respuestas[9],
        respuesta11: respuestas[10],
        respuesta12: respuestas[11],
        respuesta13: respuestas[12],
        respuesta14: "",
        respuesta15: "",
        respuesta16: "",
        respuesta17: "",
        respuesta18: "",
        respuesta19: "",
        comentariosProfesor,
        codigoCierre: closeCode,
        tipoEvaluacion,
      });
    } else {
      response = await post("EnviarEvaluacion", {
        idEvaluacion: surveyId,
        respuesta1: respuestas[0],
        respuesta2: respuestas[1],
        respuesta3: respuestas[2],
        respuesta4: respuestas[3],
        respuesta5: respuestas[4],
        respuesta6: respuestas[5],
        respuesta7: respuestas[6],
        respuesta8: respuestas[7],
        respuesta9: respuestas[8],
        respuesta10: respuestas[9],
        respuesta11: respuestas[10],
        respuesta12: respuestas[11],
        respuesta13: respuestas[12],
        respuesta14: respuestas[13],
        respuesta15: respuestas[14],
        respuesta16: respuestas[15],
        respuesta17: respuestas[16],
        respuesta18: respuestas[17],
        respuesta19: respuestas[18],
        comentariosProfesor,
        codigoCierre: closeCode,
        tipoEvaluacion,
      });
    }

    if (response.error !== "") {
      loaded = true;
      alert(response.error);
    } else {
      navigate("/cuestionario-gracias", { replace: true });
    }
  };

  $: if (closeCode) {
    checkCloseCode();
  }

  $: if (comentariosProfesor && comentariosProfesor !== "") {
    comentariosProfesor = sanitizeString(comentariosProfesor);
  }
</script>

{#if loaded}
  <div class="screen">
    <div class="screenheader">
      <div class="headerbigtitle">
        <div class="headertitletxt leftalign">
          <strong class="textbold">Cuestionario de evaluación</strong>
        </div>
        <div class="headertitletxt subtitletext leftalign">
          Curso <strong class="textbold">{academicYear}</strong>
        </div>
      </div>
      <img
        src="/images/logo-uex-white.png"
        loading="lazy"
        width="50"
        sizes="(max-width: 479px) 60px, (max-width: 767px) 55px, (max-width: 991px) 65px, 80px"
        srcset="images/logo-uex-white-p-500.png 500w, images/logo-uex-white.png 780w"
        alt=""
        class="logoheader"
      />
    </div>
    <div class="screenbody">
      <div class="autoformsection width80">
        <div class="infocuestionarioleftcolumn">
          <!--<div class="infosectioncuestionario hiddenelement">
          <div class="formtitle staticwidth">Centro</div>
          <div class="formcombobox fullwidth">Facultad de Enfermería</div>
        </div>
        <div class="infosectioncuestionario hiddenelement">
          <div class="formtitle staticwidth">Plan</div>
          <div class="formcombobox fullwidth">Grado en Enfermería</div>
        </div>-->
          <div class="infosectioncuestionario">
            <div class="formtitle staticwidth">Profesor</div>
            <div class="formcombobox fullwidth topmargin">
              {profesor}
            </div>
          </div>
        </div>
        <div class="infocuestionariorightcolumn">
          <!--<div class="infosectioncuestionario hiddenelement">
          <div class="formtitle staticwidth">Departamento</div>
          <div class="formcombobox fullwidth">Producción Experimental</div>
        </div>-->
          <div class="infosectioncuestionario">
            <div class="formtitle staticwidth">Asignatura</div>
            <div class="formcombobox fullwidth topmargin">
              {asignatura}
            </div>
          </div>
          <!--<div class="infosectioncuestionario hiddenelement">
          <div class="formtitle staticwidth"><br />Grupo</div>
          <div class="formcombobox fullwidth">Grupo 1 de Prácticas</div>
        </div>-->
        </div>
      </div>
      {#if tipoEvaluacion === "teoria"}
        <QuestionTitle lightText="Sobre el" boldText="estudiante" />
        {#each cuestionario1 as question, index}
          <Question
            {question}
            numQuestion={index + 1}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index]}
            error={respuestasError[index]}
          />
        {/each}
        <QuestionTitle lightText="Sobre la" boldText="metodología docente" />
        {#each cuestionario2 as question, index}
          <Question
            {question}
            numQuestion={index + 3}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 2]}
            error={respuestasError[index + 2]}
          />
        {/each}
        <QuestionTitle
          lightText="Sobre la"
          boldText="organización de las enseñanzas"
        />
        {#each cuestionario3 as question, index}
          <Question
            {question}
            numQuestion={index + 10}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 9]}
            error={respuestasError[index + 9]}
          />
        {/each}
      {:else}
        <QuestionTitle lightText="Sobre el" boldText="alumno" />
        {#each cuestionario1 as question, index}
          <Question
            {question}
            numQuestion={index + 1}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index]}
            error={respuestasError[index]}
          />
        {/each}
        <QuestionTitle lightText="Sobre la" boldText="metodología docente" />
        {#each cuestionario2 as question, index}
          <Question
            {question}
            numQuestion={index + 7}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 6]}
            error={respuestasError[index + 6]}
          />
        {/each}
        <QuestionTitle lightText="Sobre la" boldText="atención al estudiante" />
        {#each cuestionario3 as question, index}
          <Question
            {question}
            numQuestion={index + 10}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 9]}
            error={respuestasError[index + 9]}
          />
        {/each}
        <QuestionTitle lightText="Sobre la" boldText="evaluacion" />
        {#each cuestionario4 as question, index}
          <Question
            {question}
            numQuestion={index + 13}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 12]}
            error={respuestasError[index + 12]}
          />
        {/each}
        <QuestionTitle lightText="Valoración" boldText="global" />
        {#each cuestionario5 as question, index}
          <Question
            {question}
            numQuestion={index + 16}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 15]}
            error={respuestasError[index + 15]}
          />
        {/each}
        <QuestionTitle
          lightText="Sobre las"
          boldText="obligaciones docentes del profesor"
        />
        {#each cuestionario6 as question, index}
          <Question
            {question}
            numQuestion={index + 17}
            onAnswer={(index, answer) => clickAnswer(index, answer)}
            selected={respuestas[index + 16]}
            error={respuestasError[index + 16]}
          />
        {/each}
      {/if}
      <QuestionTitle lightText="Comentarios" boldText="sobre el profesor" />
      <textarea maxlength="500" bind:value={comentariosProfesor} />
      <div class="formquestiontitle">
        Para enviar el cuestionario, escribe el código facilitado por el/la
        responsable
      </div>
      <div class="writefield widthtablet">
        <input type="text" maxlength="20" bind:value={closeCode} />
        <img
          src="/images/edit-grey.svg"
          loading="lazy"
          width="22"
          height="22"
          alt=""
          class="comboboxicon"
        />
      </div>
      <div
        href="#"
        class="greenbuttonstyle widthtablet w-button"
        on:click={() => sendCuestionario()}
      >
        Enviar cuestionario
      </div>
    </div>
    <div class="screenfooter">
      <img
        src="/images/logo-uex-complete-black.png"
        loading="lazy"
        width="300"
        sizes="(max-width: 479px) 83vw, 250px"
        srcset="/images/logo-uex-complete-black-p-500.png 500w, /images/logo-uex-complete-black-p-800.png 800w, /images/logo-uex-complete-black-p-1080.png 1080w, /images/logo-uex-complete-black-p-1600.png 1600w, /images/logo-uex-complete-black-p-2000.png 2000w, /images/logo-uex-complete-black-p-2600.png 2600w, /images/logo-uex-complete-black-p-3200.png 3200w, /images/logo-uex-complete-black.png 3994w"
        alt=""
        class="logobottom"
      />
    </div>
  </div>
{/if}

<style>
  input {
    margin: 0px;
    height: 100%;
    border: 0px;
    width: 100%;
    background-color: transparent;
    font-weight: bold;
    font-size: 18px;
  }

  div.writefield {
    padding-left: 25px;
  }

  textarea {
    width: 100%;
    height: 100px;
    margin-bottom: 40px;
    resize: none;
    font-size: 15px;
  }
</style>
